import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Link from 'next/link';
import { array } from 'prop-types';
import classNames from 'classnames';
import dynamic from 'next/dynamic';

import styles from '../../MarketIndex/MarketDetail/index.module.scss';
import { searchPropertyListSelector } from '../../../store/market/selectors';
import {
  largeIndent,
  smallIndent,
  DEFAULT_CENTER_MAP,
} from '../../../utils/constants';
import { fetchDataCitiesForImmobilienPage } from '../../../utils/page';
import Loader from '../../common/Loader';
import {
  fetchAutoSuggestText,
  setCurrentPlace,
} from '../../../store/market/actions';

const Map = dynamic(() => import('../../../components/common/Map/index'), {
  ssr: false,
});
const PropertyView = ({ options }) => {
  const dispatch = useDispatch();
  const selectedFilters = useSelector(searchPropertyListSelector);

  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);

  const searchCurrentCity = useMemo(() => [...options], [options]);

  useEffect(() => {
    dispatch(fetchAutoSuggestText(searchCurrentCity[0]?.url.split('-')[0]))
      .then((res) => {
        if (res?.data?.data?.length) {
          const searchCurrentPlace = res.data.data.find(
            (item) => item.kgs === options[0].kgs,
          );
          dispatch(setCurrentPlace(searchCurrentPlace));
        } else {
          dispatch(
            setCurrentPlace({
              fulltitle: searchCurrentCity[0].name,
              urlpath: searchCurrentCity[0].url,
            }),
          );
        }
      })
      .catch((e) => console.log(e));
  }, [searchCurrentCity, options, dispatch]);

  useEffect(() => {
    setCities(options);
    const { selected, ...rest } = selectedFilters;
    if (selected) {
      setLoading(true);
      fetchDataCitiesForImmobilienPage(rest).then((res) => {
        setCities(res);
        setLoading(false);
      });
    }
  }, [dispatch, options, selectedFilters]);

  const renderCityLink = useCallback(
    (city, idx) => (
      <div className={`g-color-gray-dark-v3 ${styles.citiesBlock}`} key={idx}>
        <Link
          href={`/immobilien/${encodeURIComponent(city.url)}/wohnung-mieten`}
          passHref
        >
          <a className="g-color-gray-dark-v3" data-cy="city-link">
            {city.name}
          </a>
        </Link>
        <span data-cy="city-angebote">
          {city?.numberOfItems
            ? `${city.numberOfItems} Angebote`
            : '0 Angebote'}
        </span>
      </div>
    ),
    [],
  );

  return (
    <div className={`container ${styles.marketContainer}`}>
      <div
        style={{
          paddingBottom: `${smallIndent}rem`,
          paddingTop: `${largeIndent - 0.5625}rem`,
        }}
      >
        <h1
          style={{ marginBottom: `${smallIndent - 0.5625}rem` }}
          className="g-color-gray-dark-v3 g-font-weight-700 text-start text-uppercase g-pr-20"
        >
          Immobilien in Deutschland
        </h1>
        <h3
          className="h3 g-color-gray-dark-v3 text-uppercase"
          style={{ paddingBottom: `${smallIndent}rem` }}
        >
          die gefragtesten Lagen
        </h3>
        <div className={`row no-gutters ${styles.marketBlock}`}>
          <div
            className={`d-flex align-items-end col-4 g-pr-40 g-pl-0 g-mb-0--lg
           ${styles.textPositionLeftBlockProperty}`}
          >
            <div className="d-flex flex-column" style={{ width: '100%' }}>
              {loading ? (
                <Loader />
              ) : (
                <div
                  className={classNames(
                    'list-unstyled g-pt-20',
                    styles.cityContainer,
                  )}
                >
                  {cities?.map(renderCityLink)}
                </div>
              )}
            </div>
          </div>
          <div
            className={classNames(
              'col-8 g-mb-50 g-mb-0--lg pr-0 g-pl-10',
              styles.iframeBlock,
            )}
          >
            <Map
              mapId={'correctionDetail'}
              height="570px"
              selectedLayer="Wohnlage"
              center={DEFAULT_CENTER_MAP}
            />
          </div>
        </div>
        <div className="g-pt-40" />
      </div>
    </div>
  );
};

PropertyView.propTypes = {
  options: array.isRequired,
};

export default PropertyView;
